import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class DeleteGroupApi {
    private authClient: AuthClient;

    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async deleteGroup(groupId: string) {

        try {

            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.post(
                `${this.authClient.getApiRoot()}/group/${groupId}/delete`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );
            return {
                statusCode: response.status,
                badRequestMessage: response.data
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data
            }
        }
    }
}

export default DeleteGroupApi;
